import React from 'react';
import { Steps, Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import * as Icons from '@ant-design/icons';

import Loading from '../../common/Loading';

import FormPersona from '../../tramites/formularios/FormPersona';
import FormCertificacion from '../../tramites/formularios/FormCertificacion';
import getCertificacionPorId from '../../../graphql/querys/tramites/getCertificacionPorId.graphql';
import insertPersona from '../../../graphql/mutations/persona/insertPersona.graphql';
import updateCertificacion from '../../../graphql/mutations/tramites/updateCertificacion.graphql';
import getCertificaciones from '../../../graphql/querys/tramites/getCertificaciones.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import { errorService } from '../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertPersona, {
    name: 'createPers',
  }),
  graphql(updateCertificacion, {
    name: 'updateCert',
    options: {
      refetchQueries: [{ query: getCertificaciones }],
    },
  }),
  graphql(getUsuario)
)
class EditarCertificacion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      persona: {},
      certificacion: {},
      id_TipoCertificacion: '',
      cantidad: 0,
      step: 0,
      guardado: false,
      loading: true,
    };

    this.props.client
      .query({
        query: getCertificacionPorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        const cert = res.data.getCertificacionPorId;

        this.setState({
          loading: false,
          persona: cert.persona,
          cantidad: cert.cantidad,
          id_TipoCertificacion: cert.tipo_certificacion._id,
          fecha_creacion: cert.fecha_creacion,
          _id: cert._id,
        });
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);
        errorService(err, {
          _id: this.props.match.params.id,
        });
        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });

    this.guardarPersona = this.guardarPersona.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.guardarDatosCertificacion = this.guardarDatosCertificacion.bind(this);
  }

  guardarPersona(persona) {
    this.setState(
      {
        persona: {
          ...this.state.persona,
          ...persona,
        },
      },
      function() {
        this.siguientePaso();
      }
    );
  }

  guardarDatosCertificacion(datos) {
    //Actualizamos la persona si es que existe, o la insertamos si creo una nueva.
    //Todo esto gracias al upsert en mongoDB.

    //Armamos una copia del objeto persona, y le sacmaos la propiedad __typename para que sea del tipo "InputPersona" de graphql
    let copiaPersona = this.state.persona;
    delete copiaPersona.__typename;
    delete copiaPersona.fecha_ultimo_cambio;

    this.props
      .createPers({
        variables: { persona: copiaPersona },
      })
      .then(res => {
        let persona = res.data.insertPersona;

        let nuevaCertificacion = {
          cantidad: datos.cantidad,
          fecha_creacion: this.state.fecha_creacion,
          idPersona: persona._id,
          idTipo_Certificacion: datos.id_TipoCertificacion,
          idOrganismo: this.props.data.getUsuario.organismo._id,
        };

        this.props
          .updateCert({
            variables: { _id: this.state._id, nuevaCertificacion },
          })
          // eslint-disable-next-line no-unused-vars
          .then(resCert => {
            notification.success({
              message: 'Actualizacion Correcta',
              description:
                'Se ha registrado los nuevos datos de la certificacion',
            });

            this.props.history.push('/');
          })
          .catch(err => {
            console.log('Error en la actualizacion de la certificacion');
            console.log(err);
            errorService(err, {
              _id: this.state._id,
              nuevaCertificacion,
            });
            Modal.error({
              title: 'Error en la actualizacion de la certificacion',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      })
      .catch(err => {
        console.log('Error en la actualizacion de la certificacion');
        console.log(err);
        errorService(err, {
          persona: copiaPersona,
        });
        Modal.error({
          title: 'Error en la actualizacion de la certificacion',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  siguientePaso() {
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  }

  anteriorPaso() {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const { Step } = Steps;
    let { step } = this.state;

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Certificacion</Breadcrumb.Item>
          <Breadcrumb.Item>Editar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Editar Certificacion
          </h2>
          <br />
          <Steps className="stepsFormularios" current={step}>
            <Step title="Datos Persona" />
            <Step title="Datos de la Certificacion" />
          </Steps>
          <div style={estiloContent}>
            {step === 0 && (
              <FormPersona
                className="formularios"
                onSubmit={this.guardarPersona}
                onAnterior={() => this.props.history.goBack()}
                persona={this.state.persona}
              />
            )}
            {step === 1 && (
              <FormCertificacion
                onSubmit={this.guardarDatosCertificacion}
                datos={{
                  id_TipoCertificacion: this.state.id_TipoCertificacion,
                  cantidad: this.state.cantidad,
                }}
                config={{ creacion: false }}
              />
            )}
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(EditarCertificacion);
